'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './frontpage-slider-editor.routes';

export class FrontpageSliderEditorComponent {

  constructor($uibModal, SettingsService, dialogs) {
    'ngInject';
    this.$uibModal = $uibModal;
    this.dialogs = dialogs;
    this.SettingsService = SettingsService;

    this.toolbarDefinition = [
      ["bold","italics","underline"],
      ["h1","h2","h3","h4","h5"],
      ["p","pre","clear"],
      ["undo","redo"],
      ["codeMirror"],
      ["backgroundColor","fontColor","fontName", "fontSize"]
    ];

    this.sortableOptions = {
      handle: '.handle'
    };

    SettingsService.getByName({name: 'frontpage-settings'}, setting => {
      this.setting = setting;
      this.settings = setting.data;
    })
  }

  removeSlide($event, idx) {
    $event.stopPropagation();

    var dlg = this.dialogs.confirm("Delete Slide?", "Do you really want to delete the "+(idx+1) + ". slide?");
    dlg.result.then(() => {
      this.settings.slides.splice(idx,1);
    }, () => {
      // Cancel
    });

  }

  openAssetBrowserModal(idx) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetBrowser',
      resolve: {
        config: function() {
          return {
            restrictToFileTypes: ["image/jpeg", "image/png"],
            restrictToPublicFiles: true
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (newlySelectedAssets) {

        if(newlySelectedAssets.length) {
          newlySelectedAssets.forEach(asset => {
            that.settings.slides.push("/api/storage/public/" + asset._id);
          });
        }

      },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModal(idx) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {
            acceptedFileTypes: 'image/*',
            forcePublic: true
          }
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        if (result.length) {
          result.forEach(storageId => {
            that.settings.slides.push("/api/storage/public/" + storageId);
          });
        }

      },
      function () { /* cancel */ }
    );

  }

  save() {
    this.setting.data = this.settings;
    this.SettingsService.update({id: this.setting._id}, this.setting, _ => {
      this.dialogs.notify("Success","The frontpage slider has been updated successfully");
    }, err => {
      console.log('There has been an error.')
    });
  }
}

export default angular.module('conduu.frontpageSliderEditor', [uiRouter])
  .config(routes)
  .component('frontpageSliderEditor', {
    template: require('./frontpage-slider-editor.html'),
    controller: FrontpageSliderEditorComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/frontpage-slider/frontpage-slider-editor.component.js